// Some interaction-count fields (e.g. chat) come back as a boolean
// has-unread flag rather than a numeric count. Normalize either shape into a
// number a tab badge can render, without ever leaking a literal "true"/
// "false" into the UI.
export function toBadgeCount(value: unknown): number {
  if (typeof value === "number") return value;
  return value ? 1 : 0;
}
